// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".career-box[data-v-56f5e37a]{background-color:#fff;position:relative;background-color:var(--lightgrey-price-box);transition-duration:.3s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
